import { useCallback } from 'react';
import { useDaily, useDailyEvent } from '@daily-co/daily-react';
import { useAuthStore } from '@/stores/authStore';
import { useConversaStore } from '@/stores/conversaStore';
import type { AppMessage } from '@/types/chat.types';

export const useChat = () => {
  const callObject = useDaily();
  const user = useAuthStore((state) => state.user);
  const addChatMessage = useConversaStore((state) => state.addChatMessage);

  // Listen for incoming messages from other participants
  useDailyEvent(
    'app-message',
    useCallback(
      (event: any) => {
        if (!event?.data) return;

        const data = event.data as AppMessage;

        // Validar que é uma mensagem de chat legítima, não um evento de transcrição
        // Mensagens de chat devem ter senderName, text e timestamp
        if (!data.senderName || !data.text || !data.timestamp) {
          console.log('⚠️ Ignoring invalid app-message (possibly transcription event):', data);
          return;
        }

        // Add to Conversa store
        addChatMessage(data.senderName, data.text);
      },
      [addChatMessage]
    )
  );

  // Send message to all participants
  const sendMessage = useCallback(
    (text: string) => {
      if (!callObject || !user || !text.trim()) return;

      const message: AppMessage = {
        senderName: user.name,
        text: text.trim(),
        timestamp: new Date().toISOString(),
      };

      // Send to all participants via Daily.co
      callObject.sendAppMessage(message, '*');

      // Add to Conversa store immediately for better UX
      addChatMessage(message.senderName, message.text);
    },
    [callObject, user, addChatMessage]
  );

  return { sendMessage };
};
